// extracted by mini-css-extract-plugin
export default {"Assistance":"Assistance_Assistance__PQObJ","list":"Assistance_list__dS0Kg","view-more":"Assistance_view-more__3iumb"};